{
  "created_by": "Créé par",
  "created": "Créé",
  "filter": "Filtre",
  "example": {
    "test": "Je m'appelle {{ name }} et j'ai {{ age }} ans"
  },
  "buttons": {
    "cancel": "Annuler",
    "save": "Enregistrer",
    "save_changes": "Enregistrer les modifications",
    "next": "Suivant",
    "continue": "Continuer",
    "close": "Fermer",
    "selectValue": "Sélectionnez {{ value }}",
    "remove": "Supprimer",
    "confirm": "Confirmer",
    "saveAndFinish": "Enregistrer et terminer",
    "saveAndClose": "Enregistrer et fermer",
    "back": "Retour",
    "copyValue": "Copier la valeur",
    "pasteValue": "Coller la valeur",
    "delete": "Supprimer",
    "deleting": "Suppression",
    "deleteAll": "Tout supprimer",
    "undo": "Annuler",
    "redo": "Refaire",
    "import": "Importer",
    "export": "Exporter",
    "add": "Ajouter",
    "share": "PARTAGEZ",
    "key": "Clé",
    "create": "Créez",
    "expand": "Élargir",
    "collapse": "Effondrement",
    "select": "Sélectionnez",
    "select_all": "Tout sélectionner",
    "upload": "Téléverser",
    "download": "Télécharger",
    "add_another_item": "Ajouter un autre article",
    "move": "Déplacer",
    "edit": "Modifier",
    "edit_name": "Modifier le nom",
    "removeImage": "Supprimer l'image",
    "finish": "Terminer",
    "click_to_edit": "Cliquez pour modifier {{ name }}",
    "click_to_select": "Cliquez pour sélectionner {{ name }}",
    "click_to_deselect": "Cliquez pour désélectionner {{ name }}",
    "see_all": "Voir tout",
    "skip": "Ignorer",
    "submit": "Soumettre",
    "support": "Contacter le support",
    "upgrade": "Mettre à niveau",
    "createLayer": "Créer une couche",
    "disable": "Désactiver",
    "enable": "Activer",
    "copy": "Copier",
    "maximise": "Maximiser",
    "minimise": "Minimiser",
    "retry": "Réessayez"
  },
  "toasts": {
    "creating_resource": "Création de {{ resource }} Nous vous dirons quand il sera prêt",
    "creation_completed": "Création terminée pour {{ resource }}",
    "resource_complete": "{{ resource }} terminée"
  },
  "selected": "Sélectionné {{ selectedNumber }}",
  "no_children_available": "Aucun {{ childType }} disponible",
  "loading...": "Chargement en cours...",
  "saving": "Épargner",
  "pending_save": "Sauvegarde en attente",
  "saved": "Enregistré",
  "creating": "Création",
  "errorLoading": "Erreur lors du chargement de {{ resourceName }}",
  "yes": "Oui",
  "no": "Non",
  "none": "Aucune",
  "selection": {
    "none_selected": "Aucun sélectionné",
    "all_selected": "Tous sélectionnés",
    "selected": "Sélectionné"
  },
  "upload": {
    "select_csv": "Sélectionnez un fichier CSV",
    "change_csv": "Modifier le fichier CSV",
    "upload_errors_placeholder": "S'il y a des problèmes avec votre fichier, ils apparaîtront ici",
    "import_complete": "Importation terminée avec succès"
  },
  "sort": {
    "most_relevant": "Le plus pertinent"
  },
  "settings": "Réglages",
  "no_results": "Aucun résultat",
  "name": "Nom",
  "in_development": "[En développement]",
  "exports": {
    "success_message": "{{ exportName }} a été exporté avec succès. Cliquez sur le lien pour le télécharger",
    "error_message": "{{ exportName }} n'a pas pu exporter. Veuillez réessayer ultérieurement ou contacter le support Iventis.",
    "start_message": "L'exportation de {{ exportName }} a commencé, nous vous ferons savoir quand elle sera prête"
  },
  "all": "Tous",
  "copied_to_clipboard": "Copié dans le presse-papiers",
  "click_for_details": {
    "whole": "Cliquez ici pour plus de détails",
    "click": "Cliquez",
    "for_more": "pour plus de détails"
  },
  "here": "ici",
  "delete_confirmation_message": "Êtes-vous sûr de vouloir supprimer {{ entity }}",
  "unavailable": "Non disponible",
  "link": "Lien",
  "powered_by": "Propulsé par",
  "boolean": {
    "true": "Vrai",
    "false": "Faux"
  },
  "delete": "Supprimer",
  "learnMore": "En savoir plus",
  "items": "articles",
  "csv": "csv",
  "success": "Succès",
  "alert": "Alerte",
  "warning": "Avertissement",
  "error": "Erreur"
}